import globals from "./globals";
import { drawFirstFrame } from "./firstFrame";
import { setupRenderTargets } from "./renderTargets";
import { currentSeedType } from "./setupRightPaneGui";
import { exportImage } from "./exportImage";

export function setupKeyboard() {
  window.addEventListener("keyup", (e) => {
    switch (e.key) {
      case " ":
        e.preventDefault();
        globals.isPaused = !globals.isPaused;
        break;
      case "r":
      case "R":
        setupRenderTargets();
        drawFirstFrame(currentSeedType);
        break;
      case "s":
      case "S":
        exportImage();
        break;
      default:
        break;
    }
  });
}
